import { Service } from "./restService";


const authApiPath = "/auth";

const login = (data) => {

    const _site = data.site + "/api";
    const url = _site + authApiPath + "/login";
    const method = 'POST';
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };
    const body = JSON.stringify({ username: data.username, password: data.password });

    const requestOptions = { method: method, headers: headers, body: body };

    return fetch(url, requestOptions).then((response) => {
        if (!response.ok) {
            throw Error(response);
        }

        let contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            return response.json();
        } else {
            return response.text();
        }
    })
};

class LoginService extends Service {

    autoLogin = () => {
        let response = {
            token: this.storage.getItem('thingsboard/auth', 'token', true) || null,
            refreshToken: this.storage.getItem('thingsboard/auth', 'refreshToken', true) || null,
            site: this.storage.getItem('thingsboard/state', 'site', true) || null,
            authenticated: this.storage.getItem('thingsboard/state', 'authenticated', true) || false,
        };

        response.loggedIn = (response.token && response.refreshToken &&
            ("true" === response.authenticated));
        
        /* update in-memory only storage */
        this.storage.setItem('thingsboard/auth', 'token', response.token || "");
        this.storage.setItem('thingsboard/auth', 'refreshToken', response.refreshToken || "");
        this.storage.setItem('thingsboard/state', 'site', response.site || "");
        this.storage.setItem('thingsboard/state', 'authenticated', response.authenticated || false);
        
        this.updateState({ loggedIn: response.loggedIn });
        return response;
    }

    login = (data) => {
        const url = data.site + "/api/auth/login";
        const method = 'POST';
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        const body = JSON.stringify({ username: data.username, password: data.password });

        const requestOptions = { method: method, headers: headers, body: body };

        return (this.callApi(url, requestOptions).then(
            (response) => {
                let _loggedIn = !response.error;
                this.storage.setItem('thingsboard/auth', 'token', response.token || "", true);
                this.storage.setItem('thingsboard/auth', 'refreshToken', response.refreshToken || "", true);
                this.storage.setItem('thingsboard/state', 'site', data.site || "", true);
                this.storage.setItem('thingsboard/state', 'authenticated', _loggedIn, true);

                this.updateState({ loggedIn: _loggedIn });
                return response;
            }
        )//then
            .catch((error) => {
                this.updateState({ loggedIn: false });
                throw Error(error);
            }) //catch
        )//return
    }

    logout = () => {
        this.storage.removeItem('thingsboard/auth', 'token', true);
        this.storage.removeItem('thingsboard/auth', 'refreshToken', true);
        this.storage.removeItem('thingsboard/state', 'authenticated', true);
        this.storage.removeItem('thingsboard/state', 'site', true);
        this.updateState({ loggedIn: undefined });
    }
}

export default LoginService;
export {
    LoginService,
    login
}